module.exports = __webpack_public_path__ + "img/livinglab-logo-dark-bg.40575934.svg";